















import { Component, Vue } from 'vue-property-decorator';

import util from './common/utility';
import 'bootstrap/dist/js/bootstrap.bundle';

@Component({})
export default class App extends Vue {
    public user = util.initUser();
    public homeRoute = util.loginSuccessRoute;

    public mounted() {
        util.eventBus.$on('user-info', (user: any) => {
            this.user = user;
        });
    }

    public get isLoggedIn() {
        return util.isLoggedIn(this.user);
    }
}
